<main>
    <h1 i18n="@@PaymentSuccessHeader">Das Upgrade war erfolgreich und eine ausgezeichnete Wahl</h1>
    <h2 i18n="@@PaymentSuccessText">Mit diesen Funktionen wird das Lademanagement für Sie zu einem Vergnügen</h2>
    
    <ul class="hero-features">
        <li>
            <h3 i18n="@@PaymentSuccessTransactionHeader">Sehen Sie alle Informationen zu allen Ladevorgängen</h3>
            <p i18n="@@PaymentSuccessTransactionText">
                Jeder Ladevorgang wird aufgezeichnet damit Sie sehen können, wer, wann und wie viel geladen hat.
                <a [routerLink]="['/evaluation/transactions']" id="to_transactions">Zu den Ladevorgängen</a>
            </p>
        </li>
        <li>
            <h3 i18n="@@PaymentSuccessRemoteStartHeader">Starten Sie Ladevorgänge mit Ihrem Smartphone</h3>
            <p i18n="@@PaymentSuccessRemoteStartText">
                Es braucht nicht noch eine Karte. Starten Sie den Ladevorgang ganz einfach mit Ihrem Smartphone &mdash; ohne App.
                <a [routerLink]="['/chargingstations']" id="to_chargingstations">Zu den Ladestationen</a>
            </p>
        </li>
        <li>
            <h3 i18n="@@PaymentSuccessNightPlanHeader">Planen Sie Ihre Ladevorgänge für Ihren Nachtstromtarif</h3>
            <p i18n="@@PaymentSuccessNightPlanText">
                Laden Sie Ihr Fahrzeug, wenn es am günstigsten für Sie ist und zwar völlig automatisch mit Ihren eigenen Ladeplänen.
                <a class="disabled">Zu den Ladeplänen</a>
            </p>
        </li>
    </ul>

    <h2 i18n="@@MoreFeaturesHeader">Und da ist noch so viel mehr</h2>

    <ul class="features" i18n="@@MoreFeaturesText">
        <li><strong>Autorisieren</strong> Sie ausgewählte Benutzer an ausgewählten Ladestationen</li>
        <li><strong>Gruppieren</strong> Sie Benutzer und Ladestationen nach Ihren Bedürfnissen</li>
        <li><strong>Durchsuchen, filtern und sortieren</strong> Sie Ladevorgänge, Ladestationen und Benutzer</li>
        <li><strong>Bieten Sie kostenloses Laden</strong> über ausgewählte Ladestationen an mit dem FreeCharge-Modus</li>
        <li><strong>Analysieren</strong> Sie Ihre gesamten Daten, die wir grafisch für Sie aufbereitet haben</li>
        <li><strong>Automatisieren</strong> Sie die Erzeugung von Lieferscheinen für Ihre Benutzer</li>
        <li><strong>Verwenden Sie beliebig viele Karten</strong> zum Laden an Ihren Ladestationen</li>
        <li><strong>Fernsteuern</strong> Sie Ihre Ladestationen jederzeit und von überall</li>
    </ul>

    <h2 i18n="@@AddYourFirstChargingStationHeader">Bereit?<br>Legen Sie Ihre erste Ladestation an</h2>

    <p class="text-center">
        <a [routerLink]="['/chargingstations/summary/create']" id="creat_first_chargingstation" class="btn btn-yellow" i18n="@@AddYourFirstChargingStationButton">Los geht's!</a>
    </p>
</main>
